import type { LabelInValue } from 'models';
import { Modal, type ModalOptions, message } from 'ui';
import { useInviteUsersMutation } from '../../../queries';
import { MembersInviteForm, type MembersInviteFormValues } from './members-invite-form';

type MembersInviteModalOptions = {
  community: LabelInValue;
};

type P = {
  onCancel: () => void;
  options: ModalOptions<MembersInviteModalOptions>;
};

const MembersInviteModal = ({ onCancel, options }: P) => {
  const { isPending: isInvitingUsers, mutate: inviteUsers } = useInviteUsersMutation();

  const onSubmit = (data: MembersInviteFormValues) => {
    inviteUsers(
      {
        id: data.communityId,
        invitees: {
          emails: [],
          phones: [],
          userIds: data.users.map((user) => user.value),
        },
      },
      {
        onSuccess() {
          message.success('Invitations sent successfully');
          onCancel();
        },
      },
    );
  };

  return (
    <Modal isOpened={options.isOpened} onCancel={onCancel} title="Select members to invite">
      {options.isOpened ? (
        <Modal.HugContent>
          <MembersInviteForm
            community={options.community}
            isSubmitting={isInvitingUsers}
            onCancel={onCancel}
            onSubmit={onSubmit}
          />
        </Modal.HugContent>
      ) : null}
    </Modal>
  );
};

export default MembersInviteModal;
